import { z } from "zod";

export const ZTakSchema = z.object({
  // 13
  isActive: z.boolean().default(false),
  tekst: z.string(),
  kompakteTak: z.object({
    // 13.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
    rettvendteTak: z.object({
      // 13.1.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
      plantUnderlag: z.object({
        // 13.1.1.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      stalplateTak: z.object({
        // 13.1.1.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
    omvendteTak: z.object({
      // 13.1.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    duotak: z.object({
      // 13.1.3
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    gronneTak: z.object({
      // 13.1.4
      isActive: z.boolean().default(false),
      tekst: z.string(),
      sedumtak: z.object({
        // 13.1.4.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      lettBeplantning: z.object({
        // 13.1.4.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      tungBeplantning: z.object({
        // 13.1.4.3
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
    blaTak: z.object({
      // 13.1.5
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  elementTak: z.object({
    // 13.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  skraLuftedeTretak: z.object({
    // 13.3
    isActive: z.boolean().default(false),
    tekst: z.string(),
    takflateOppvarmetAreal: z.object({
      // 13.3.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    kaldeLoft: z.object({
      // 13.3.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  glasstak: z.object({
    // 13.4
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  solcellerPaTak: z.object({
    // 13.5
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  takterrasser: z.object({
    // 13.6
    isActive: z.boolean().default(false),
    tekst: z.string(),
    lettTrafikkert: z.object({
      // 13.6.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    tungtTrafikkert: z.object({
      // 13.6.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
});

export type ITakSchema = z.infer<typeof ZTakSchema>;
